module.exports = __webpack_public_path__ + "media/move.fdbde26d.ogg";